module.exports = __webpack_public_path__ + "media/images/flags/64/Romania-66ea4cc115983d0974ba3f16fcd12d47.png";